import React from "react";

const Person = ({person}) => {
    return (
        <p>{person}</p>
    )
};

export default Person